import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ACTIONS, CURRENCY, CURRENCY_SYMBOL, SPIN_WIN_PRIZES, convertNumToCurr, getEllipsis } from "src/app/shared/constants/app-enums";
import { ILootboxCard } from "../lootbox.interface";

@Component({
  selector: "app-reward-card",
  templateUrl: "./reward-card.component.html",
  styleUrls: ["./reward-card.component.scss"],
})
export class RewardCardComponent {
  SPIN_WIN_PRIZES = SPIN_WIN_PRIZES;
  @Input({ required: true }) cardDetails!: ILootboxCard;
  @Output() onAction = new EventEmitter<ACTIONS>()
  ACTIONS = ACTIONS;
  CURRENCY_SYMBOL = CURRENCY_SYMBOL;
  CURRENCY = CURRENCY;

  convertNumToCurr(num: number) {
    return convertNumToCurr(num);
  }

  getEllipsis(text: string, max: number) {
    return getEllipsis(text, max);
  }
}
